<script>
    import Button from "$lib/Button.svelte";
</script>

<Button color="transparent" on:click {...$$restProps}>
    <slot></slot>
</Button>
